export const isExist = (value: unknown): value is object | string | number | boolean => {
  if (typeof value === 'boolean') return true;
  if (typeof value === 'number') return true;
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim() !== '' && value !== 'null' && value !== 'undefined';
  if (typeof value === 'object') return Object.keys(value).length > 0;
  return true;
};

export const isEmptyValue = (value: unknown) => {
  return !isExist(value);
};

export function cleanObject<T extends Record<string, unknown>>(obj: T): T {
  for (const propName in obj) {
    if (isEmptyValue(obj[propName])) {
      delete obj[propName];
    }
  }
  return obj;
}

export function toArray<T>(value: T | T[] | null | undefined): T[] {
  if (Array.isArray(value)) return value;
  if (isEmptyValue(value) || !value) return [];
  return [value];
}

export const isQuillContentEmpty = (value: string | undefined) => {
  if (!value) return true;
  const plainText = value.replace(/<(.|\n)*?>/g, '').trim();
  return plainText.length === 0;
};
